import Footer from "../../components/Footer";
import Header from "../../components/Header";
// Import the feasibility component we created

import SiteFeasibility from "../../components/Service/Subservice/site-fesiablity";
import SubServiceBanner from "../../components/Service/Subservice/subservicebanner";

export default function SiteFeasibilityPage() {
    return (
        <>
            <Header/>
            {/* Banner updated for feasibility and due diligence */}
            <SubServiceBanner title={"Site Feasibility & Due Diligence"}/>
            
            <SiteFeasibility/>
            
            <Footer/>
        </>
    )
}